module.exports = __webpack_public_path__ + "static/media/cnodejs.86f6a7c2.svg";